import React, {useState} from 'react';

import {hooks} from '../../hooks';
import {items} from '../../items';
import {AcademyType} from '../../types';
import {Routes} from '../../routes';
import {components} from '../../components';

export const Academy: React.FC = () => {
  const dispatch = hooks.useDispatch();

  const navigate = hooks.useNavigate();
  const {academyLoading, academy} = hooks.useGetAcademy();

  const location = hooks.useLocation();

  const [opacity, setOpacity] = useState<number>(0);
  // const [selectedCategory, setSelectedCategory] = useState<string>(menuName);

  // const filteredActivities = activities.filter((activity: ActivitiesType) =>
  //   activity.title.includes(selectedCategory.toLowerCase()),
  // );

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  // const renderSearch = (): JSX.Element | null => {
  //   if (
  //     menuLoading ||
  //     dishesLoading ||
  //     menu.length === 0 ||
  //     dishes.length === 0
  //   ) {
  //     return null;
  //   }

  //   return (
  //     <section
  //       className='row-center container'
  //       style={{gap: 5, marginTop: 10}}
  //     >
  //       <button
  //         style={{
  //           height: 50,
  //           display: 'flex',
  //           alignItems: 'center',
  //           paddingLeft: 5,
  //           gap: 14,
  //           flex: 1,
  //           backgroundColor: 'var(--white-color)',
  //           borderRadius: 10,
  //         }}
  //         onClick={() => navigate(Routes.Search)}
  //       >
  //         <svg.SearchSvg />
  //         <span className='t16'>Search ...</span>
  //       </button>
  //       <button
  //         style={{
  //           width: 50,
  //           height: 50,
  //           backgroundColor: 'var(--white-color)',
  //           borderRadius: 10,
  //         }}
  //         className='center'
  //         onClick={() => navigate(Routes.Filter)}
  //       >
  //         <svg.FilterSvg />
  //       </button>
  //     </section>
  //   );
  // };

  // const renderCategories = (): JSX.Element | null => {
  //   if (
  //     menuLoading ||
  //     dishesLoading ||
  //     menu.length === 0 ||
  //     dishes.length === 0
  //   ) {
  //     return null;
  //   }

  //   return (
  //     <section style={{width: '100%', marginTop: 14, paddingBottom: 20}}>
  //       <Swiper
  //         spaceBetween={8}
  //         slidesPerView={'auto'}
  //         pagination={{clickable: true}}
  //         navigation={true}
  //         mousewheel={true}
  //       >
  //         {menu.map((category: MenuType, index, array) => {
  //           const isLast = index === array.length - 1;

  //           return (
  //             <SwiperSlide
  //               key={category.id}
  //               style={{
  //                 width: 'auto',
  //                 marginLeft: index === 0 ? 20 : 0,
  //                 marginRight: isLast ? 20 : 0,
  //               }}
  //               onClick={() => setSelectedCategory(category.name)}
  //             >
  //               <div
  //                 style={{
  //                   padding: '10px 20px',
  //                   borderRadius: 10,
  //                   border: '1px solid red',
  //                   borderColor:
  //                     selectedCategory === category.name
  //                       ? 'var(--main-turquoise)'
  //                       : 'var(--white-color)',
  //                   backgroundColor: 'var(--white-color)',
  //                 }}
  //               >
  //                 <h5
  //                   style={{
  //                     textTransform: 'capitalize',
  //                     color:
  //                       selectedCategory === category.name
  //                         ? 'var(--main-turquoise)'
  //                         : 'var(--main-color)',
  //                   }}
  //                 >
  //                   {category.name}
  //                 </h5>
  //               </div>
  //             </SwiperSlide>
  //           );
  //         })}
  //       </Swiper>
  //     </section>
  //   );
  // };

  const renderContent = (): JSX.Element | null => {
    if (
      academyLoading ||
      academy.length === 0
    ) {
      return null;
    }

    return (
      <main className='scrollable container'>
        <ul style={{display: 'grid', gridTemplateColumns: '1fr', gap: 15, paddingTop: 10, paddingBottom: 20}}>
          {academy.map(
            (item: AcademyType, index: number, array: AcademyType[]) => {
              const isLast = index === array.length - 1;

              return (
                <items.AcademyItem
                  academy={item}
                  index={index}
                  key={item.id}
                  isLast={isLast}
                />
              );
            },
          )}
        </ul>
      </main>
    );
  };

  const renderLoader = (): JSX.Element | null => {
    if (
      academyLoading ||
      academy.length === 0
    ) {
      return <components.Loader />;
    }
    return null;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {/* {renderSearch()}
      {renderCategories()} */}
      {renderContent()}
      {renderLoader()}
    </div>
  );
};
